import { MessageBarModel } from "presentation/model/MessageBar";
import { Dispatch, SetStateAction } from "react";
import BaseViewModel from "./BaseViewModel";

interface MessageBarVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<MessageBarModel>> | ((value: SetStateAction<MessageBarModel>) => void),
    ]
}

export const MessageBarVM = ({ dispatch, }: MessageBarVMProps) => {
    const [messageBarDispatch] = dispatch;

    const showError = (message: string, isActiveScreen: boolean = false) => {
        messageBarDispatch(prevState => ({
            ...prevState,
            errorDuration: 5,
            errorCountDownFlag: 0,
            isOpen: true,
            isNotificationError: true,
            message: message,
            isWarning: false,
            isActiveScreen: isActiveScreen
        }));
    }

    const showWarining = (message: string, isActiveScreen: boolean = false) => {
        messageBarDispatch(prevState => ({
            ...prevState,
            errorDuration: 5,
            errorCountDownFlag: 0,
            isOpen: true,
            isNotificationError: false,
            message: message,
            isWarning: true,
            isActiveScreen: isActiveScreen
        }));
    }


    const showClose = () => {
        messageBarDispatch(prevState => ({
            ...prevState,
            isOpen: false,
            message: '',
            errorCountDownFlag: -1,
            errorDuration: 0,
        }));
    }


    const showSuccess = (message: string, isActiveScreen: boolean = false) => {
        messageBarDispatch(prevState => ({
            ...prevState,
            errorDuration: 5,
            errorCountDownFlag: 0,
            isOpen: true,
            isNotificationError: false,
            message: message,
            isWarning: false,
            isActiveScreen: isActiveScreen
        }));
    }

    return {
        showClose: showClose,
        showWarining: showWarining,
        showError: showError,
        showSuccess: showSuccess
    }
} 